import './ScheduleDialog.css';
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'react-redux-multilingual';
import { styled } from '@mui/material/styles';
import Scheduler from 'material-ui-cron';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Divider from '@mui/material/Divider';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';

import TimeZones from '../../../libraries/TimeZones';
import SchedulerLocale from '../../../libraries/SchedulerLocale';

import {
  GetScripts,
} from '../../../services/Workspace.service';

import { 
  TranslateContents,
} from '../../../services/Auth.service';

function ScheduleDialog(props) {
    const { translate, open, handleClose, handleAgree, scheduleInfor={} } = props;

    const [activeStep, setActiveStep] = React.useState(0);
    const [triggers, setTriggers] = React.useState();
    const [description, setDescription] = React.useState();
    const [cronError, setCronError] = React.useState('') // get error message if cron is invalid
    const [isAdmin, setIsAdmin] = React.useState(true) // set admin or non-admin to enable or disable high frequency scheduling (more than once a day)
    const [ID, setID] = React.useState();
    const [scriptID, setScriptID] = React.useState();
    const [timeZone, setTimeZone] = React.useState();
    const [utcOffset, setUtcOffset] = React.useState();
    const [scripts, setScripts] = React.useState();
    const [excludingHolidaysFlg, setExcludingHolidaysFlg] = React.useState();
    const [excludingWeekendsFlg, setExcludingWeekendsFlg] = React.useState();
    const [translating, setTranslating] = React.useState(false);

    const steps = [
        translate('selectrobot'), 
        translate('edittrigger'), 
        translate('confirmschedule')
    ];

    const descriptionEl = '.MuiDialog-container.MuiDialog-scrollPaper > div > div > div > div h6';

    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
          top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
              'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
          },
        },
        [`&.${stepConnectorClasses.completed}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
              'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
          },
        },
        [`& .${stepConnectorClasses.line}`]: {
          height: 3,
          border: 0,
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
          borderRadius: 1,
        },
      }));
      
      const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
          backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
          boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        }),
        ...(ownerState.completed && {
          backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        }),
      }));
      
    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
      
        const icons = {
          1: <PrecisionManufacturingIcon />,
          2: <WatchLaterIcon />,
          3: <AssignmentTurnedInIcon />,
        };
      
        return (
          <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
          </ColorlibStepIconRoot>
        );
    }
      
    ColorlibStepIcon.propTypes = {
        /**
         * Whether this step is active.
         * @default false
         */
        active: PropTypes.bool,
        className: PropTypes.string,
        /**
         * Mark the step as completed. Is passed to child components.
         * @default false
         */
        completed: PropTypes.bool,
        /**
         * The label displayed in the step icon.
         */
        icon: PropTypes.node,
    };

    const handleClickBack = () => {
      if(activeStep > 0) {
        setActiveStep(activeStep - 1);
      }
    }

    const handleClickNext = async () => {
      if(activeStep < 2) {
        let locale = localStorage.getItem('_locale');
        let value = document.querySelector(descriptionEl)?.innerHTML;
        let additional = 
        `${excludingHolidaysFlg === 1 ? `. ${translate('excludingholidays')}` : ''}` +
        `${excludingWeekendsFlg === 1 ? `. ${translate('excludingweekends')}` : ''}` +
        `.`
        ;
        if(value) {
          switch (locale) {
            case "vi":
              setTranslating(true);
              TranslateContents({ locale, value })
              .then(res => {
                // console.log(res)
                setDescription(res.data._value + additional);
                setTranslating(false);
              })
              break;
            default:
              setDescription(value + additional);
              break;
          }
        }
        setActiveStep(activeStep + 1);
      } else if(activeStep === 2) {
        handleAgree({
          ID,
          scriptID,
          timeZone,
          utcOffset,
          triggers,
          excludingHolidaysFlg,
          excludingWeekendsFlg,
          description
        });
      }
    }

    useEffect(() => {
      setActiveStep(0);
      if(scheduleInfor.ID) {
        setID(scheduleInfor.ID);
        setScriptID(scheduleInfor.scriptID);
        setTimeZone(scheduleInfor.timeZone);
        setUtcOffset(scheduleInfor.utcOffset);
        setTriggers(scheduleInfor.triggers);
        setDescription(scheduleInfor.description);
        setExcludingHolidaysFlg(scheduleInfor.excludingHolidaysFlg);
        setExcludingWeekendsFlg(scheduleInfor.excludingWeekendsFlg);
      } else {
        setID("");
        setScriptID("");
        setTimeZone("Asia/Ho_Chi_Minh");
        setUtcOffset("+07:00:00");
        setTriggers('0 12 * * *');
        setDescription("At 12:00 AM");
        setExcludingHolidaysFlg(0);
        setExcludingWeekendsFlg(0);
      }
    }, [scheduleInfor])

    useEffect(() => {
      GetScripts("", 99999999, 0)
      .then(res => {
          // console.log(res)
          setScripts(res.data.datas[1]);
      })
    }, [open])

    return (
        <div>
            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>
                    {translate('schedule')}
                    <IconButton className="connection-close" aria-label="search" onClick={handleClose} >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pb: 0 }}>
                    <Stepper 
                        alternativeLabel 
                        activeStep={activeStep} 
                        connector={<ColorlibConnector />}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <Box className='schedule-box'>
                        {activeStep === 0 &&
                        <>
                          <Autocomplete
                            fullWidth
                            options={scripts}
                            defaultValue={scripts?.find(script => script.scriptID === scriptID)}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} label={translate('robotname')} />}
                            onChange={(event, newValue) => {
                              setScriptID(newValue.scriptID);
                            }}
                          />
                        </>}
                        {activeStep === 1 &&
                        <>
                          <Autocomplete
                            fullWidth
                            size='small'
                            options={TimeZones}
                            defaultValue={TimeZones?.find(tz => tz.name === timeZone)}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} label={translate('timezone')} />}
                            sx={{ textAlign: "left", p: "0 8px 0 8px", boxSizing: "border-box" }}
                            onChange={(event, newValue) => {
                              setTimeZone(newValue.name);
                              setUtcOffset(newValue.utcOffset);
                            }}
                          />
                          <Divider sx={{ my: 2 }}/>
                          <Scheduler
                              cron={triggers}
                              setCron={setTriggers}
                              setCronError={setCronError}
                              isAdmin={isAdmin}
                              locate={localStorage.getItem('_locale')}
                              customLocale={
                                (localStorage.getItem('_locale') === 'vi') ? SchedulerLocale.vi :
                                (localStorage.getItem('_locale') === 'ja') ? SchedulerLocale.ja :
                                null
                              }
                          />
                          <FormGroup>
                            <FormControlLabel 
                              control={
                                <Switch 
                                  checked={excludingHolidaysFlg}
                                  onChange={(event) => setExcludingHolidaysFlg(event.target.checked ? 1 : 0)}
                                />
                              }
                              label={translate('excludingholidays')} 
                            />
                            <FormControlLabel 
                              control={
                                <Switch 
                                  checked={excludingWeekendsFlg}
                                  onChange={(event) => setExcludingWeekendsFlg(event.target.checked ? 1 : 0)}
                                />
                              }
                              label={translate('excludingweekends')} 
                            />
                          </FormGroup>
                        </>}
                        {activeStep === 2 &&
                        <>
                          <TextField
                            fullWidth
                            label={translate('robotname')}
                            value={scripts.find(script => script.scriptID === scriptID)?.name}
                            variant="outlined"
                            sx={{ mb: 2 }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            fullWidth
                            label={translate('timezone')}
                            value={timeZone}
                            variant="outlined"
                            sx={{ mb: 2 }}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            fullWidth
                            multiline
                            label={translate('description')}
                            value={description}
                            variant="outlined"
                            disabled={translating}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {translating && <CircularProgress color='secondary' disableShrink />}
                                </InputAdornment>
                              ),
                              readOnly: true,
                            }}
                          />
                        </>}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ py: 2, justifyContent: "center" }}>
                    <Button
                      size="small" 
                      disableElevation 
                      color='secondary' 
                      onClick={handleClickBack}
                    >
                        {translate('back')}
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      disableElevation
                      color="info"
                      onClick={handleClickNext}
                      disabled={
                        ((activeStep === 0) && (!scriptID)) ? true :
                        ((activeStep === 1) && (!timeZone || !triggers)) ? true :
                        ((activeStep === 2) && (!scriptID || !timeZone || !description || translating)) ? true :
                        false
                      }
                    >
                        {translate(activeStep < 2 ? 'next' : 'ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default withTranslate(ScheduleDialog);